import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Definition = ({ term, description, children, className }) => (
    description || children ? (
        <div className={classNames('pp-definition', className)}>
            {
                term &&
                <dt className="pp-definition__term">
                    {term}:
                </dt>
            }
            <dd className="pp-definition__description">
                {children || description}
            </dd>
        </div>
    ) : null
);

Definition.propTypes = {
    term: PropTypes.string.isRequired,
    description: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.number]
    ),
    className: PropTypes.string,
    children: PropTypes.node,
};

export default Definition;



// WEBPACK FOOTER //
// ./src/js/shared/Definition.jsx